import { useQuery } from "@apollo/react-hooks";
import gql from "graphql-tag";
import { FeatureFlag } from "./features.datatypes";

interface FeatureFlagsData {
    features: FeatureFlag[];
}

interface FeatureFlagData {
    feature: FeatureFlag;
}

export const GET_FEATURE_FLAGS_QUERY = gql`
    query {
        features {
            id
            name
            slug
            enabled
        }
    }
`;

export const GET_FEATURE_FLAG_QUERY = gql`
    query($slug: String!) {
        feature(slug: $slug) {
            id
            name
            slug
            enabled
        }
    }
`;

export const getFeatures = () =>
    useQuery<FeatureFlagsData>(GET_FEATURE_FLAGS_QUERY, {});

export const getFeature = (slug: string) =>
    useQuery<FeatureFlagData>(GET_FEATURE_FLAG_QUERY, {
        variables: { slug }
    });

export default {
    getFeatures,
    getFeature
};
